import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-cheng91-entrance': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20platform%20entrance%20gateway%20concept%2C%20warm%20amber%20and%20cream%20gradient%20background%2C%20clean%20geometric%20shapes%2C%20soft%20lighting%2C%20abstract%20technology%20atmosphere%2C%20professional%20yet%20approachable%20aesthetic%2C%20high%20quality%20editorial%20photography%20with%20smooth%20textures&width=800&height=480&seq=article-cheng91-entrance&orientation=landscape',
  'article-register-guide': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20registration%20form%20interface%20design%20concept%2C%20warm%20cream%20and%20soft%20amber%20color%20palette%2C%20modern%20UI%20elements%20with%20rounded%20corners%2C%20professional%20digital%20product%20photography%20style%2C%20soft%20diffused%20lighting%2C%20welcoming%20atmosphere&width=800&height=480&seq=article-register-guide&orientation=landscape',
  'article-member-benefits': 'https://readdy.ai/api/search-image?query=Elegant%20membership%20and%20VIP%20concept%20visual%2C%20warm%20golden%20and%20cream%20tones%2C%20minimalist%20luxury%20aesthetic%2C%20abstract%20geometric%20crown%20shapes%2C%20soft%20gradient%20background%2C%20premium%20branding%20photography%20style%2C%20refined%20atmosphere&width=800&height=480&seq=article-member-benefits&orientation=landscape',
  'article-platform-features': 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20dashboard%20interface%20concept%2C%20warm%20amber%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20UI%20design%2C%20soft%20abstract%20shapes%2C%20professional%20technology%20photography%2C%20smooth%20gradients%2C%20organized%20layout&width=800&height=480&seq=article-platform-features&orientation=landscape',
  'article-login-fix': 'https://readdy.ai/api/search-image?query=Minimalist%20login%20screen%20troubleshooting%20concept%2C%20warm%20cream%20and%20soft%20amber%20background%2C%20clean%20interface%20elements%2C%20help%20and%20support%20theme%2C%20professional%20digital%20product%20photography%2C%20soft%20diffused%20lighting%2C%20approachable%20aesthetic&width=800&height=480&seq=article-login-fix&orientation=landscape',
  'article-security-guide': 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20protection%20concept%2C%20warm%20amber%20and%20cream%20gradient%20background%2C%20abstract%20shield%20and%20lock%20geometric%20shapes%2C%20minimalist%20design%2C%20professional%20atmosphere%2C%20soft%20lighting%2C%20trustworthy%20aesthetic&width=800&height=480&seq=article-security-guide&orientation=landscape',
  'article-summer-event': 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20celebration%20and%20event%20promotion%20concept%2C%20warm%20golden%20amber%20and%20cream%20tones%2C%20festive%20yet%20minimalist%20aesthetic%2C%20abstract%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20joyful%20atmosphere%2C%20professional%20branding%20photography&width=800&height=480&seq=article-summer-event&orientation=landscape',
  'article-speed-tips': 'https://readdy.ai/api/search-image?query=Fast%20digital%20connection%20and%20speed%20optimization%20concept%2C%20warm%20amber%20and%20cream%20gradient%2C%20abstract%20data%20flow%20geometric%20shapes%2C%20minimalist%20technology%20aesthetic%2C%20soft%20lighting%2C%20dynamic%20yet%20clean%20composition&width=800&height=480&seq=article-speed-tips&orientation=landscape',
};

export default function LatestArticles() {
  const latestArticles = articles
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新文章
            </h2>
            <p className="text-foreground-600">成91最新使用教程与平台动态</p>
          </div>
          <Link
            to="/category/zuixin-dongtai"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 overflow-hidden cursor-pointer flex flex-col"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-50 text-accent-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime} 分钟阅读</span>
                  <span className="ml-auto flex items-center gap-1 text-primary-500 font-medium">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/zuixin-dongtai"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}